import { Controller } from "@hotwired/stimulus"

// Staff event list: switch ON = attended, OFF = no_show (unrecorded shows as OFF).
export default class extends Controller {
  static targets = ["status", "track", "knob", "checkbox"]

  submitOnChange() {
    const checked = this.checkboxTarget.checked
    this.statusTarget.value = checked ? "attended" : "no_show"
    this.reflectVisualState(checked)
    const form = this.element.closest("form")
    if (form) form.requestSubmit()
  }

  reflectVisualState (checked) {
    if (this.hasTrackTarget) {
      this.trackTarget.classList.toggle("bg-success", checked)
      this.trackTarget.classList.toggle("bg-primary-light-color/40", !checked)
    }
    if (this.hasKnobTarget) {
      this.knobTarget.classList.toggle("translate-x-5", checked)
      this.knobTarget.classList.toggle("translate-x-0", !checked)
    }
  }
}
